import React from 'react';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
import { tomos, menus } from '../data/content';
import { Reveal } from './Reveal';
export function Tomos() {
  return <section className="bg-cream py-20 sm:py-28" id="contenido" aria-labelledby="tomos-title" data-id="element-217" data-mp="1h32ps8w0p6qu">
      <div className="mx-auto max-w-6xl px-6" data-id="element-218" data-mp="1h4x9jjvjystc">
        <Reveal className="max-w-3xl" data-id="element-219" data-mp="1cbb7smqxg9cb">
          <p className="inline-flex items-center gap-2 rounded-full bg-sand px-3.5 py-1.5 text-sm font-medium text-mint-700 ring-1 ring-inset ring-cream-line" data-id="element-220" data-mp="1ca9ojuzrcgji">
            <BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-221" data-mp="1m1e00kq85j9l" />
            Lo que recibes
          </p>
          <h2 id="tomos-title" className="mt-5 font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-222" data-mp="200nd3bj4vx9c">
            3 tomos: de la receta al pedido cobrado
          </h2>
          <p className="mt-4 text-lg text-ink-soft" data-id="element-223" data-mp="5op67g8ardgm">
            Primero las recetas, luego los menús armados con esas recetas y al final el plan para venderlos. Cada tomo usa los mismos códigos y los mismos números.
          </p>
        </Reveal>

        <ol className="mt-12 grid gap-px overflow-hidden rounded-3xl bg-cream-line md:grid-cols-3" data-id="element-224" data-mp="34ovluvm0pvi6">
          {tomos.map((tomo, index) => <li key={tomo.number} className="flex" data-id="element-225" data-mp="3eoe4n8q6zb8n" data-mpi={index}>
              <Reveal delay={index * 0.04} className="flex h-full w-full flex-col bg-sand p-7" data-id="element-226" data-mp="3emt5t6wuh64z">
                <span className="font-display text-4xl leading-none text-terra" data-id="element-227" data-mp="3jhpap7n6jnzi">
                  {String(tomo.number).padStart(2, '0')}
                </span>
                <h3 className="mt-5 font-display text-xl text-ink" data-id="element-228" data-mp="3sf9ean8ilwda">
                  {tomo.title}
                </h3>
                {tomo.subtitle ? <p className="mt-1 text-sm font-medium uppercase tracking-wide text-mint-700" data-id="element-229" data-mp="17wvk3rzhav9">
                    {tomo.subtitle}
                  </p> : null}
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-230" data-mp="232eboa5u3erh">
                  {tomo.description}
                </p>
                <ul className="mt-5 space-y-2.5" data-id="element-231" data-mp="282jud0u4lqxf">
                  {tomo.points.map(point => <li key={point} className="flex items-start gap-2.5" data-id="element-232" data-mp="200jbh5v7yhha">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mint-700" aria-hidden="true" data-id="element-233" data-mp="1vyy1ptdzejbb" />
                      <span className="text-sm leading-relaxed text-ink-soft" data-id="element-234" data-mp="29y7dmgv5mr9h">{point}</span>
                    </li>)}
                </ul>
              </Reveal>
            </li>)}
        </ol>

        <Reveal delay={0.04} data-id="element-235" data-mp="2iy3vnzn1grvk">
          <div className="mt-12 rounded-3xl bg-sand p-7 ring-1 ring-inset ring-cream-line sm:p-9" data-id="element-236" data-mp="2ixaxhn25bap1">
            <h3 className="font-display text-2xl text-ink" data-id="element-237" data-mp="2ewiq6zcu3fve">Los 6 menús del Tomo 2</h3>
            <p className="mt-2 text-[15px] text-ink-soft" data-id="element-238" data-mp="2sndqvod6iqnw">
              Precio sugerido por persona, en pesos mexicanos. Son referencias: tú ajustas con tus costos y tu zona.
            </p>
            <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-239" data-mp="32no59caya44n">
              {menus.map(menu => <li key={menu.code} className="flex items-center justify-between gap-4 rounded-2xl bg-cream px-5 py-4" data-id="element-240" data-mp="2xob9g223pmpx">
                  <span data-id="element-241" data-mp="3hamr8rr1g6bz">
                    <span className="block text-xs font-semibold uppercase tracking-[0.14em] text-terra-dark" data-id="element-242" data-mp="3h77brntgcva1">
                      {menu.code} · {menu.people} personas
                    </span>
                    <span className="mt-1 block font-display text-lg text-ink" data-id="element-243" data-mp="37d8f34c5e3ph">{menu.name}</span>
                  </span>
                  <span className="whitespace-nowrap text-sm font-semibold text-mint-700" data-id="element-244" data-mp="2xlcgzta2adl9">
                    ${menu.pricePerPerson} MXN
                  </span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}